import React, { Component } from 'react'
import moment from "moment";
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createPublisher,
  updatePublisher,
  getPublisher,
  deletePublisher } from '../../../services/PublisherService'

import {
    getMagazineList } from '../../../services/MagazineService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class PublisherPageView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      publisherId: null,
      publisher: null,
      magazineList: []
    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    log.debug(this.props.match.params)
    // load info
    let publisher = await getPublisher(this.props.match.params.id)
    log.debug(publisher)

    let magazineList = await getMagazineList();
    this.setState({magazineList: magazineList})

    log.debug('all data is loaded.')
    this.setState({publisherId: this.props.match.params.id})
    this.setState({publisher: publisher})
    this.setState({isLoading: false})
  }
  handleSubmit = async (e) => {
    e.preventDefault()
    log.debug(this.publisher_uuid.value);
    log.debug(this.state.value);
  }

  async handleDelete(publisherId, e) {
    e.preventDefault()
    log.debug(publisherId)
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        try{
          await deletePublisher(publisherId)
          log.debug('delete success.')

          this.state.publisher.status = 'D'
          this.setState({publisher: this.state.publisher})
        }catch(err){
          log.debug(err)
          this.setState(setErrorMsg(err))
        }

    } else {
        log.debug('delete cancel')
    }
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/publisher'>Publisher</Link> ->
          View
        </h4>
        <div className="panel panel-default">
    <div className="panel-heading">
        <Link className="btn btn-success" to={`/publisher/edit/${this.state.publisherId}`}>Edit</Link>
        &nbsp;
        <button
          type="button"
          onClick={(e) => this.handleDelete(this.state.publisherId, e)}
          className="btn btn-small btn-danger">Delete</button>
          <br/> <br/>
        <Link className="btn btn-success" to={`/magazine/add/${this.state.publisherId}`}>Add New Magazine</Link>
    </div>
    {/* /.panel-heading */}
    <div className="panel-body">
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{width: '20%'}}>Name</th>
                        <th>value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>publisher_id</td>
                        <td>{this.state.publisherId}</td>
                    </tr>
                    <tr>
                        <td>publisher_uuid</td>
                        <td>{this.state.publisher.publisher_uuid}</td>
                    </tr>
                    <tr>
                        <td>owner_id</td>
                        <td>{this.state.publisher.owner_id}</td>
                    </tr>
                    <tr>
                        <td>tag</td>
                        <td>{this.state.publisher.tag}</td>
                    </tr>
                    <tr>
                        <td>title</td>
                        <td>{this.state.publisher.title}</td>
                    </tr>
                    <tr>
                        <td>description</td>
                        <td>{this.state.publisher.description}</td>
                    </tr>
                    <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.publisher.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr>
                    <tr>
                        <td>status</td>
                        <td>{this.state.publisher.status}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        {/* /.table-responsive */}
    </div>
    {/* /.panel-body */}
</div>

<h4 className="page-header">
  Magazine List
</h4>
<hr/>
<table className="table">
    <thead>
        <tr>
            <th>magazine_id</th>
            {/* <th>magazine_uuid</th>
            <th>publisher_id</th>
            <th>owner_id</th> */}
            <th>tag</th>
            <th>title</th>
            {/* <th>description</th> */}
            {/* <th>latest_issue_id</th> */}
            <th>is_publish</th>
            {/* <th>sort_order</th>
            <th>share_text</th>
            <th>embed_html</th> */}
            <th>date_created</th>
            <th>status</th>
            <th> Actions </th>
        </tr>
    </thead>
    <tbody>
      {
        this.state.magazineList.map((data, index) =>
        <tr key={index}>
          <td>{data.id}</td>

            {/* <td>{data.data().magazine_uuid} </td>
            <td>{data.data().publisher_id} </td>
            <td>{data.data().owner_id} </td> */}
            <td>{data.data().tag} </td>
            <td>{data.data().title} </td>
            {/* <td>{data.data().description} </td>
            <td>{data.data().latest_issue_id} </td> */}
            <td>{data.data().is_publish} </td>
            {/* <td>{data.data().sort_order} </td>
            <td>{data.data().share_text} </td>
            <td>{data.data().embed_html} </td> */}
            <td>{moment(data.data().date_created).fromNow()} </td>
            <td>{data.data().status} </td>
          {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
          <td>
            <Link className="btn btn-small btn-primary" to={`/magazine/view/${data.id}`}>view</Link>
          </td>
        </tr>
      )
      }
    </tbody>
</table>

      </div>

    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PublisherPage/PublisherPageView.js